import { FC, useEffect } from 'react';
import { scrollToTop } from '../shared/helpers/scrollHelper';
import { connect, useDispatch } from 'react-redux';
import { checkoutErrorShownAction } from '../actions/checkoutUIActions';

//constants
import { ERRORS } from '../constants/checkoutConstants';
import { DeniedPaymentAuthorizationError } from 'dibs-error-tools/exports/ErrorMessages/constants';

// components
import CheckoutMainErrorMessage from './CheckoutMainErrorMessage';
import { GridCol, GridRow } from 'dibs-elements/src/Grid';

import styles from './styles/CheckoutMainError.scss';

type Props = {
    globalProcessingError: (typeof ERRORS)[keyof typeof ERRORS] | DeniedPaymentAuthorizationError;
    globalUserMismatchError: (typeof ERRORS)[keyof typeof ERRORS] | null;
    hasShownGlobalProcessingError: boolean;
};

const CheckoutMainError: FC<Props> = ({
    globalUserMismatchError,
    globalProcessingError,
    hasShownGlobalProcessingError,
}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (globalProcessingError && !hasShownGlobalProcessingError) {
            dispatch(checkoutErrorShownAction());
            scrollToTop(null);
        }
    }, [globalProcessingError, hasShownGlobalProcessingError, dispatch]);

    //processing error should take priority if both exist
    const resolvedError = globalProcessingError || globalUserMismatchError;

    return (
        !!resolvedError && (
            <GridRow>
                <GridCol
                    desktop={8}
                    desktopOptions={{ offset: 2 }}
                    mobile={10}
                    mobileOptions={{ offset: 1 }}
                >
                    <div className={styles.wrapper}>
                        <CheckoutMainErrorMessage errorCode={resolvedError} />
                    </div>
                </GridCol>
            </GridRow>
        )
    );
};

type StateType = {
    ui: {
        globalUserMismatchError: (typeof ERRORS)[keyof typeof ERRORS] | null;
        globalProcessingError:
            | (typeof ERRORS)[keyof typeof ERRORS]
            | DeniedPaymentAuthorizationError;
        hasShownGlobalProcessingError: boolean;
    };
};

const ConnectedCheckoutMainError = connect((state: StateType) => ({
    globalUserMismatchError: state?.ui?.globalUserMismatchError,
    globalProcessingError: state?.ui?.globalProcessingError,
    hasShownGlobalProcessingError: state?.ui?.hasShownGlobalProcessingError,
}))(CheckoutMainError);

export default ConnectedCheckoutMainError;
